<tgt-modal [witdhModal]="'auto'" [openOrClose]="false">
  <main>

    <h3>Selecione o perfil</h3>

    <!-- @if (perfilResponsavel) {
      <tgt-select [control]="form.controls.aluno" [valueOptionSelected]="valueChangeAluno ? valueChangeAluno : ''" [error]="error" [border]="true" [label]="'Aluno*'"
                  (changeOption)="retornoOptionAluno($event)" [options]="optionAlunos" ></tgt-select >
    } @else { -->
    <tgt-select id="select-school" [valueOptionSelected]="valueChangeEscola ? valueChangeEscola : ''"
      [control]="form.controls.escola" [error]="error" [border]="true" [label]="'Escola*'"
      (changeOption)="retornoOptionEscola($event)" [options]="optionEscolas"></tgt-select>
    <!-- @if(user.permissaos.length !== 1) { -->
    <tgt-select [valueOptionSelected]="valueChangePermissao ? valueChangePermissao : ''" [control]="form.controls.role"
      [error]="error" [border]="true" [label]="'Selecione o Perfil*'" (changeOption)="retornoOptionRole($event)"
      [options]="optionPermissoes"></tgt-select>
    <!-- } -->

    <!-- } -->

    @if (isResponsavel) {
    <tgt-select id="select-profile" [valueOptionSelected]="valueChangeAluno ? valueChangeAluno : ''"
      [control]="form.controls.aluno" [error]="error" [border]="true" [label]="'Aluno*'"
      (changeOption)="retornoOptionAluno($event)" [options]="optionAlunos"></tgt-select>
    }

    <div class="action">
      <tgt-button id="select-school-button" [color]="'primary'" [disabled]="error" [fieldButton]="'field'"
        [size]="'small'" (click)="selecionar()">Confirmar
      </tgt-button>
    </div>
  </main>
</tgt-modal>
